import { Snackbar } from "@material-ui/core";

import { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import compteCaisseService from "../../../services/compteCaisse";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";

const DetailCompteCaisse = () => {
  const [name, setName] = useState("");
  const [type, setType] = useState(2);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setsuccessAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();

  const onChangeBankNameHandler = (event) => {
    setName(event.target.value);
  };

  const saveDataInBackend = () => {
    console.log(name, "Name");
    console.log(type, "type");
    let obj = {
      idUser: getCurrentUserId(),
      name: name,

      type: type,
    };
    const object = JSON.stringify(obj);
    compteCaisseService
      .addBankCaisse(object)
      .then((response) => {
        console.log(response);
        if (Object.keys(response.data)[0] === "exist") {
          setInfoAlertText(
            "Info : le code RIB est déja exist dans le systéme "
          );
          setOpenInfoAlert(true);
        } else {
          setsuccessAlertText("Enregistrement avec succés");
          setOpenSuccessAlert(true);
          window.location.href = "/allBanqueAccounts";
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  return (
    <section class="content" style={{ marginTop: "2%" }}>
      <div class="row">
        <div class="col-12">
          <div className="card card-dark">
            <div className="card-header">
              <h3 className="card-title">
                Ajouter les cordonnées de compte caisse
              </h3>
            </div>
        
                      <div className="card-body">
                        <div className="row">
                          <div className="form-group" class="col-sm-12">
                            <label htmlFor="inputName">Nom</label>
                            <input
                              placeholder="Ajouter le nom du compte"
                              onChange={onChangeBankNameHandler}
                              type="text"
                              id="inputName"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-12" style={{ marginTop: "2%" }}>
                          <button
                            className="btn btn-dark float-right"
                            onClick={saveDataInBackend}
                          >
                            Enregistrer
                          </button>
                        </div>
                      </div>
                   

              <Snackbar
                open={openErrorAlert}
                autoHideDuration={2000}
                onClose={handleEroorClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              >
                <Alert
                  variant="filled"
                  onClose={handleEroorClose}
                  severity="error"
                >
                  {errorAlertText}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openSuccessAlert}
                autoHideDuration={2000}
                onClose={handleSuccessClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              >
                <Alert
                  variant="filled"
                  onClose={handleSuccessClose}
                  severity="success"
                >
                  {successAlertText}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openInfoAlert}
                autoHideDuration={2000}
                onClose={handleInfoClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              >
                <Alert
                  variant="filled"
                  onClose={handleInfoClose}
                  severity="info"
                >
                  {infoAlertText}
                </Alert>
              </Snackbar>

   
            </div>
          </div>
        </div>
    </section>
  );
};
export default DetailCompteCaisse;
